export const solanaClusterUrls: { [key: string]: string } = {
    'mainnet-beta':
        'https://morning-floral-grass.solana-mainnet.quiknode.pro/f03f3e90bfd3511642d21898e9a94931cbb18c8f/',
    devnet: 'https://api.devnet.solana.com',
    testnet: 'https://api.testnet.solana.com',
};

export const solanaNetworkList = ['mainnet-beta', 'devnet', 'testnet'];
export const solanaAirdropNetworkList = ['devnet', 'testnet'];
